import React from 'react';
import { Box, Typography } from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

const CalendarHeader = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                mb: { xs: 4, sm: 6 },
                flexDirection: { xs: 'column', sm: 'row' },
                textAlign: { xs: 'center', sm: 'left' }
            }}
        >
            <Box
                sx={{
                    p: 1.5,
                    borderRadius: '50%',
                    bgcolor: 'primary.light',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'primary.main',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.05)'
                }}
            >
                <CalendarMonthIcon sx={{ fontSize: 32 }} />
            </Box>
            <Typography
                variant="h3"
                component="h1"
                fontWeight="800"
                sx={{
                    color: 'text.primary',
                    letterSpacing: '-0.02em'
                }}
            >
                Upcoming Events
            </Typography>
        </Box>
    );
};

export default CalendarHeader;
